export default __webpack_public_path__ + "./font/9c72e35f58c9b11545842dcf575b4b69.ttf";